<template>
  <div>
    <b-alert
      :show="getNotification.show"
      :variant="getNotification.type"
      dismissible
      class="alert alert-elevate"
      @dismissed="
        getNotification.message = '';
        getNotification.show = false;
      "
      @dismiss-count-down="10"
    >
      {{ getNotification.message }}
    </b-alert>

    <div class="row">
      <div class="col-md-12">
        <MPortlet
          v-bind.sync="{
            title: 'Roles',
            isLoading: isLoading,
            loadingText: loadingMessage
          }"
        >
          <template v-slot:toolbar>
            <router-link
              :to="{ name: 'create-admin-role' }"
              class="btn btn-label-success btn-sm btn-bold"
              v-if="userCan('add-roles')"
            >
              <i class="la la-pencil-square"></i>
              Add New
            </router-link>
            <button
              @click="reloadRecords()"
              class="btn btn-label-primary btn-sm btn-bold"
            >
              <i class="la la-refresh"></i>
              Reload
            </button>
          </template>
          <template v-slot:body>
            <v-card :flat="true">
              <!-- <v-card-title>
                Filter Records
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
                ></v-text-field>
              </v-card-title> -->
              <v-data-table
                item-key="id"
                :headers="headers"
                :items="getRecordsList"
                :options.sync="options"
                :server-items-length="getPagination.total"
                :loading="isLoading"
                loading-text="Loading... please wait"
                :items-per-page="per_page"
                :page="getPagination.current_page"
                :footer-props="footerProps"
                show-select
                v-model="selected"
                class="elevation-0"
              >
                <template v-slot:item.created_at="{ item }">
                  {{ item.created_at | moment("YYYY-MM-DD H:mm a") }}
                </template>
                <template v-slot:item.id="{ item }">
                  <div class="text-center">
                    <v-btn
                      small
                      class="ma-1 pt-0 pb-0 pr-2 pl-3"
                      tile
                      outlined
                      color="primary"
                      @click="viewRecord(item.id)"
                      v-if="checkRole(item) && userCan('read-roles')"
                    >
                      <v-icon left>mdi-eye</v-icon> View
                    </v-btn>
                    <v-btn
                      small
                      class="ma-1 pt-0 pb-0 pr-2 pl-3"
                      tile
                      outlined
                      color="success"
                      @click="editRecord(item.id)"
                      v-if="checkRole(item) && userCan('edit-roles')"
                    >
                      <v-icon left>mdi-pencil</v-icon> Edit
                    </v-btn>
                    <v-btn
                      small
                      class="ma-1 pt-0 pb-0 pr-2 pl-1"
                      tile
                      outlined=""
                      color="error"
                      @click="deleteRecord(item.id)"
                      v-if="checkRole(item, true) && userCan('delete-roles')"
                    >
                      <v-icon>mdi-delete</v-icon> Delete
                    </v-btn>
                  </div>
                </template>
              </v-data-table>
              <v-fab-transition>
                <v-btn
                  v-if="selected.length"
                  color="error"
                  fab
                  small
                  dark
                  top
                  right
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-fab-transition>
            </v-card>
          </template>
        </MPortlet>
      </div>
    </div>
    <v-dialog v-model="showView" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">View Role</span>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="5">
              <strong>Name</strong>
            </v-col>
            <v-col cols="7">
              {{ getActiveRecord.name }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <strong>Display Name</strong>
            </v-col>
            <v-col cols="7">
              {{ getActiveRecord.display_name }}
            </v-col>
          </v-row>
          <v-row v-if="getActiveRecord.created_at">
            <v-col cols="5">
              <strong>Created At</strong>
            </v-col>
            <v-col cols="7">
              {{ getActiveRecord.created_at | moment("YYYY-MM-DD H:mm a") }}
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="5">
              <strong>Permissions</strong>
            </v-col>
            <v-col cols="7">
              <span
                v-for="(permission, idx) in getActiveRecord.permissions"
                v-bind:key="idx"
              >
                {{
                  idx == getActiveRecord.permissions.length - 1
                    ? `${permission.display_name}`
                    : `${permission.display_name},`
                }}
              </span>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            class="white--text"
            @click="deleteRecord(getActiveRecord.id)"
            v-if="checkRole(getActiveRecord, true) && userCan('delete-roles')"
            >Delete</v-btn
          >
          <v-btn
            color="primary"
            @click="editRecord(getActiveRecord.id)"
            v-if="checkRole(getActiveRecord) && userCan('edit-roles')"
            >Edit</v-btn
          >
          <v-btn color="default" @click="showView = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/store/breadcrumbs.module";
import MPortlet from "@/views/partials/content/MPortlet.vue";
import { SET_ACTIVE_DATA } from "@/consts";

export default {
  name: "Roles",
  components: {
    MPortlet
  },
  metaInfo: {
    title: "Roles"
  },
  data() {
    return {
      storeNamespace: "adminRoles",
      search: null,
      selected: [],
      per_page: 25,
      options: {},
      headers: [
        { text: "Name", value: "name" },
        { text: "Display Name", value: "display_name" },
        { text: "Created", value: "created_at" },
        {
          text: "",
          value: "id",
          align: "center",
          sortable: false,
          filterable: false,
          width: 300
        }
      ],
      sortParams: {
        // name: "created_at",
        // direction: "desc"
      },
      footerProps: {
        "items-per-page-options": [25, 50, 100, 500]
      },
      loadingMessage: "Busy...",
      showView: false
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Roles", route: "roles" },
      { title: "Manage Roles" }
    ]);

    this.fetchRecords(this.options);
  },
  computed: {
    ...mapGetters("adminRoles", [
      "getRecordsList",
      "isLoading",
      "getPagination",
      "getErrors",
      "getActiveRecord"
    ]),
    getNotification() {
      return this.notification;
    }
  },
  watch: {
    options: {
      handler(options) {
        if (!this.isLoading) {
          this.fetchRecords(options);
        }
      },
      deep: true
    },
    getPagination: {
      handler(data) {
        this.options = {
          page: data.current_page,
          itemsPerPage: data.per_page,
          sortBy: [this.sortParams.name],
          sortDesc: [this.sortParams.direction === "desc"]
        };
      },
      deep: true
    }
  },
  methods: {
    reloadRecords() {
      let params = {
        page: 1,
        per_page: this.per_page,
        sort: this.sortParams.name,
        direction: this.sortParams.direction
      };

      this.setLoading(true);
      this.$store
        .dispatch(this.addNamespace("getList"), { ...params })
        .then(() => {
          this.setLoading(false);
          this.notification = {
            type: "success",
            message: "Data Loaded"
          };
        });
    },
    fetchRecords(options) {
      let params = {
        page: 1,
        per_page: this.per_page,
        sort: this.sortParams.name,
        direction: this.sortParams.direction
      };

      if (options.page) {
        params = {
          ...params,
          ...{
            page: options.page,
            per_page: options.itemsPerPage,
            sort: options.sortBy[0] || "created_at",
            direction: options.sortDesc[0] ? "desc" : "asc"
          }
        };
      }

      this.setLoading(true);
      this.$store
        .dispatch(this.addNamespace("getList"), { ...params })
        .then(() => {
          this.setLoading(false);
          this.notification = {
            type: "success",
            message: "Data Loaded"
          };
        });
    },
    viewRecord(id) {
      this.$store.commit(this.addNamespace(SET_ACTIVE_DATA), id);
      this.showView = true;
    },
    editRecord(id) {
      this.$store.commit(this.addNamespace(SET_ACTIVE_DATA), id);
      this.$router.push({ name: "edit-admin-role", params: { id } });
    },
    deleteRecord(id) {
      this.$confirm({
        message: "Are you sure you want to delete selected record?",
        confirmText: "Delete",
        cancelText: "Cancel"
      }).$on("confirmed", confirmed => {
        if (confirmed) {
          this.setLoading(true, "Please wait...");

          this.$store
            .dispatch(this.addNamespace("deleteRecord"), id)
            .then(response => {
              if (response.success) {
                this.$alert({
                  title: "Success!",
                  message: response.message
                });
              } else {
                this.$alert({
                  title: "Operation Failed!",
                  message: response.message
                });
              }
            })
            .catch(() => {
              this.$alert({
                title: "Error:",
                message: "Unable to delete record"
              });
            })
            .then(() => {
              this.setLoading(false);
            });
        }
      });

      // console.log(id);
    },
    maxRecord() {
      // console.log(this.selected);
    },
    setStatus(type, message) {
      this.notification = {
        type: type,
        message: message,
        show: true
      };
    },
    checkRole(data, isDelete) {
      if (isDelete) {
        return !this.userHasRole(data.id, true);
      }

      if (data.id == 1) {
        return this.userHasRole(data.id, true);
      }

      return true;
    }
  }
};
</script>
